export default __webpack_public_path__ + "static/media/bulksms-image.14c257f9.jpeg";